export function getQuery(options) {
  const query = {
    params: options,
  };
  return query;
}
